export const WEEKDAYS = [
  { id: 'SU', name: 'Sunday', symbol: 'S' },
  { id: 'MO', name: 'Monday', symbol: 'M' },
  { id: 'TU', name: 'Tuesday', symbol: 'T' },
  { id: 'WE', name: 'Wednesday', symbol: 'W' },
  { id: 'TH', name: 'Thursday', symbol: 'T' },
  { id: 'FR', name: 'Friday', symbol: 'F' },
  { id: 'SA', name: 'Saturday', symbol: 'S' },
];

export const FREQUENCY = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export default {
  FREQUENCY,
  WEEKDAYS,
  DEFAULT_DATE_FORMAT,
};
